<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="columns onboarding-create-site__step1">
    <div
      class="column is-5 onboarding-create-site__img onboarding-create-site__img--step1 is-hidden-mobile"
      :style="`background-image: url(${imgNoivosAbracados})`"
    ></div>

    <div class="column has-text-centered onboarding-create-site__description">
      <div class="onboarding-create-site__description--width-80">
        <h1 class="onboarding-create-site__title has-text-weight-bold">
          Como vocês estão se sentindo com os preparativos?
        </h1>
        <AnswersSquare :options="options" />
      </div>

      <buttonsNext :stepNumber="stepNumber" />
    </div>
  </div>
</template>

<script>
import verifyOnboardingCompleteMixin from '@/mixins/verifyOnboardingCompleteMixin'

import buttonsNext from '@/components/OnboardingCreationSite/ButtonsNext.vue'
import AnswersSquare from '@/components/OnboardingCreationSite/OptionsAnswersSquare.vue'
import imgNoivosAbracados from '@/assets/img/onboarding-create-site/teste.jpg'

export default {
  mixins: [verifyOnboardingCompleteMixin],

  components: {
    buttonsNext,
    AnswersSquare,
  },

  props: {
    stepNumber: Number,
  },

  data() {
    return {
      imgNoivosAbracados,
      options: [
        {
          id: 0,
          icon: '😍',
          text: 'Animados',
          answer:
            '<span class="has-text-weight-bold">Estamos animados também!</span><br /> Temos certeza que irão adorar seu site',
        },
        { id: 1, icon: '🙂', text: 'Tranquilos', answer: 'Legal, vamos lá!' },
        {
          id: 2,
          icon: '😩',
          text: 'Cansados',
          answer:
            '<span class="has-text-weight-bold">Não se preocupe</span>, estamos aqui para te ajudar!',
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.onboarding-create-site {
  &__step1 {
    margin-top: 0px !important;
    display: flex;
    min-height: fit-content;

    @media (min-width: $tablet) {
      height: auto;
    }
  }

  &__img {
    &--step1 {
      background-position: center;
    }
  }
}
</style>
